import {
    ROULETTE_STATISTIC,
    ROULETTE_REQUEST_FETCH_RECENT_BET_REPORT, ROULETTE_FETCH_RECENT_DRAW_REQUEST, ROULETTE_FETCH_RECENT_DRAW_SUCCESS,
    ROULETTE_FETCH_RECENT_DRAW_FAILURE,
} from "./constant";

import {
    ROULETTE_FETCH_DRAWING_REQUEST,
    ROULETTE_FETCH_DRAWING_SUCCESS,
    ROULETTE_FETCH_DRAWING_FAILURE,
    ROULETTE_CLEAR_DRAWING_ERROR,
} from "./constant";

const initialState = {
    draw: {
        isStopBet: false,
        isStopRender: true,
        timeCountWarning: 10,
        countDownTimer: 0,
        closeBet: 0,
        allNumbers: [],
        indexNumber: null,
        newResult: {},
        oldResult: null,
        lastResult: { detail: "" },
    },

    winReport: {
        tickets: [],
        summary: {
            totalBetAmount: 0,
            totalWinAmount: "",
            totalWinLoseAmount: "",
            currencyCode: "",
        },
        page: 0,
        size: 0,
        totals: 0,
    },

    lastDraws: [],

    resultReport: {
        items: [],
        filter: {},
        page: 0,
        size: 0,
        totals: 0,
    },

    recentBetting: [],

    statistic: {
        underOverItems: [],
        numberItems: [],
    },

    oldResult: {
        drawCode: "",
        result: 0,
        status: 1,
        createdAt: "",
        createdAtTime: "",
        underOverCode: "",
        oddEvenCode: "",
        colorCode: "",
        lottoDraw: null,
        isJackpot: false,
        jackpotType: "",
        jackpot: 1,
        jackpots: [],
    },

    newResult: {
        drawCode: "",
        result: 0,
        status: 1,
        createdAt: "",
        createdAtTime: "",
        underOverCode: "",
        oddEvenCode: "",
        colorCode: "",
        lottoDraw: null,
        isJackpot: false,
        jackpotType: "",
        jackpot: 1,
    },

    // ✅ new: api state for broken api handling
    api: {
        drawingResult: { loading: false, error: null, lastSuccessAt: null },
        recentDraw: { loading: false, error: null, lastSuccessAt: null },
        recentBetReport: { loading: false, error: null, lastSuccessAt: null },
        statistic: { loading: false, error: null, lastSuccessAt: null },
    },
};

// helper: safely pick only known keys from drawing result payload
const normalizeDrawingPayload = (payload = {}, stateDraw = {}) => {
    const safe = {};

    if (payload.draw) {
        safe.draw = {
            ...stateDraw,
            ...payload.draw,
        };
    } else {
        safe.draw = {
            ...stateDraw,
            countDownTimer:
                payload.countDownTimer ?? stateDraw.countDownTimer ?? 0,
            closeBet:
                payload.closeBet ?? stateDraw.closeBet ?? 0,
            oldResult:
                payload.oldResult ?? stateDraw.oldResult ?? null,
            newResult:
                payload.newResult ?? stateDraw.newResult ?? {},
        };
    }

    if (payload.lastDraws) safe.lastDraws = payload.lastDraws;
    if (payload.winReport) safe.winReport = payload.winReport;
    if (payload.resultReport) safe.resultReport = payload.resultReport;
    if (payload.recentBetting) safe.recentBetting = payload.recentBetting;
    if (payload.statistic) safe.statistic = payload.statistic;

    if ("oldResult" in payload) safe.oldResult = payload.oldResult;
    if ("newResult" in payload) safe.newResult = payload.newResult;

    return safe;
};

const drawing = (state = initialState, action) => {
    switch (action.type) {
        // -----------------------------
        // Statistic
        // -----------------------------
        case ROULETTE_STATISTIC:
            return {
                ...state,
                statistic: action.payload,
                api: {
                    ...state.api,
                    statistic: { loading: false, error: null, lastSuccessAt: Date.now() },
                },
            };

        // -----------------------------
        // Drawing Result (safe + error handling)
        // -----------------------------
        case ROULETTE_FETCH_DRAWING_REQUEST:
            return {
                ...state,
                api: {
                    ...state.api,
                    drawingResult: { ...state.api.drawingResult, loading: true, error: null },
                },
            };

        case ROULETTE_FETCH_DRAWING_SUCCESS: {

            const safe = normalizeDrawingPayload(action.payload, state.draw);

            return {
                ...state,
                ...safe,
                api: {
                    ...state.api,
                    drawingResult: {
                        loading: false,
                        error: null,
                        lastSuccessAt: Date.now(),
                    },
                },
            };
        }

        case ROULETTE_FETCH_DRAWING_FAILURE:
            return {
                ...state,
                api: {
                    ...state.api,
                    drawingResult: { loading: false, error: action.payload || "API error", lastSuccessAt: state.api.drawingResult.lastSuccessAt },
                },
            };

        case ROULETTE_CLEAR_DRAWING_ERROR:
            return {
                ...state,
                api: {
                    ...state.api,
                    drawingResult: { ...state.api.drawingResult, error: null },
                },
            };

        // -----------------------------
        // Recent Draw
        // -----------------------------
        case ROULETTE_FETCH_RECENT_DRAW_REQUEST:
            return {
                ...state,
                api: {
                    ...state.api,
                    recentDraw: { loading: true, error: null, lastSuccessAt: state.api.recentDraw.lastSuccessAt }
                }
            };

        case ROULETTE_FETCH_RECENT_DRAW_SUCCESS: {
            const lastResult = action.payload?.[0] ?? state.draw.lastResult;

            return {
                ...state,
                draw: {
                    ...state.draw,
                    lastResult
                },
                lastDraws: action.payload,
                api: {
                    ...state.api,
                    recentDraw: { loading: false, error: null, lastSuccessAt: Date.now() }
                }
            };
        }

        case ROULETTE_FETCH_RECENT_DRAW_FAILURE:
            return {
                ...state,
                api: {
                    ...state.api,
                    recentDraw: {
                        loading: false,
                        error: action.payload,
                        lastSuccessAt: state.api.recentDraw.lastSuccessAt
                    }
                }
            };

        // -----------------------------
        // Recent Bet Report
        // -----------------------------
        case ROULETTE_REQUEST_FETCH_RECENT_BET_REPORT:
            return {
                ...state,
                recentBetting: action.payload ?? [],
                api: {
                    ...state.api,
                    recentBetReport: { loading: false, error: null, lastSuccessAt: Date.now() },
                },
            };

        default:
            return state;
    }
};

export default drawing;